import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { Loading } from "@/components";
import { LoginModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";
import { AuthType, Network } from "@/network";
import { UserInfo } from "@/types/Login";
import * as CryptoJS from 'crypto-js'
import { Encrypt } from "@/util/Encrypt";

@Component<LoginLoginController>({
    components: {
        Loading,
    },
})
export default class LoginLoginController extends Vue {
    private isLoading = true;
    private doubleClick = false;
    private isPwdShow = false;

    private login = TCBReceiptApi.Protobuf.Login.create();
    private pwdOrigin = "";
    private errMsg: {
        identification: string,
        account: string,
        password: string,
        checkCode: string,
    } = {
            identification: "",
            account: "",
            password: "",
            checkCode: "",
        };
    private verificationCode: {
        uid: string,
        imgSrc: string,
    } = {
            uid: "",
            imgSrc: "",
        };
    private requiredMsg: {
        identification: boolean,
        account: boolean,
        password: boolean,
        checkCode: boolean,
    } = {
        identification: false,
        account: false,
        password: false,
        checkCode: false,
    };
    private isCapsLock = false;   
    private showLogin = true;       

    public async created() {
        if(this.showLogin){
            // get first code pic
            await this.refresh();

            this.isLoading = false;

            await this.sleep(1500);
            const userAgent = navigator.userAgent; // 取得瀏覽器的userAgent字串 藉此辨認
            if (!(userAgent.indexOf("Chrome") > -1 || userAgent.indexOf("Edg") > -1)) { // Trident => IE
                alert("本網站建議使用Chrome、Edge瀏覽器瀏覽");
            }
        }
    }

    public mounted() {
        window.addEventListener('keyup', this.eventEnter);

        const userAgent = navigator.userAgent;
        const ua = navigator.userAgent.toLowerCase();
        const isLineApp = userAgent.indexOf("Line") > -1; // Line 內建瀏覽器
        const isFbApp = userAgent.indexOf("FBAV") > -1 || userAgent.indexOf("FBAN") > -1;// FB App 內建瀏覽器
        const isIgApp = ua.indexOf("instagram") > -1;// FB App 內建瀏覽器
        const isWeixinApp = ua.indexOf("micromessenger") > -1; // 微信內建瀏覽器
        if(isLineApp || isFbApp || isIgApp || isWeixinApp){
          this.showLogin = false;
        }
    }

    public beforeDestroy() {
        window.removeEventListener('keyup', this.eventEnter);
    }    

    private async sleep(ms: number) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }

    private async checkAndSubmit() {
        let isEmpty = false;

        // init
        this.errMsg.identification = "";
        this.errMsg.account = "";
        this.errMsg.password = "";
        this.errMsg.checkCode = "";
        this.requiredMsg.identification = false;
        this.requiredMsg.account = false;
        this.requiredMsg.password = false;
        this.requiredMsg.checkCode = false;

        if (this.login.identification === "") {
            this.requiredMsg.identification = true;
            isEmpty = true;
        }
        if (this.login.account === "") {
            this.requiredMsg.account = true;
            isEmpty = true;
        }
        if (this.pwdOrigin === "") {
            this.requiredMsg.password = true;
            isEmpty = true;
        }
        if (this.login.checkCode === "") {
            this.requiredMsg.checkCode = true;
            isEmpty = true;
        }

        if (isEmpty) return false;

        await this.submit();
    }

    private async submit() {
        
        if (!this.doubleClick) {
            this.doubleClick = true;

            /* send value */
            this.isLoading = true;

            const item = this.login as TCBReceiptApi.Protobuf.Login;
            const encoder = new TextEncoder();
            item.password = encoder.encode(this.pwdOrigin);
            item.e2eePassword = await Encrypt.getE2EEpd(this.pwdOrigin);
            item.account = CryptoJS.SHA256(this.login.account).toString();
            console.log(item);
            const loginQuery = TCBReceiptApi.Protobuf.Login.encode(item).finish();
            
            // 驗證碼
            const errorCodeForCheckCode = await LoginModel.checkCode(loginQuery);
            if (errorCodeForCheckCode === TCBReceiptApi.Protobuf.ErrorCode.EC_CAPTCHA_ERROR) {
                this.errMsg.checkCode = "驗證碼錯誤";
                this.refresh();
                this.isLoading = false;
                this.doubleClick = false;
                this.login.checkCode = "";
                this.login.account = "";
                return false;
            }

            // 登入
            const responseInfo = await LoginModel.login(loginQuery);
            const errorCode = responseInfo.errorCode as number;

            this.doubleClick = false;
            this.isLoading = false;

            if (errorCode !== TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
                if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_USER_IS_NOT_EXISTS) {
                    this.errMsg.identification = "特店代號/統編錯誤或帳號不存在";
                } else if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_USER_IS_DISABLE) {
                    this.errMsg.identification = "此帳號已停用";
                } else if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_USER_LOGIN_ERROR) {
                    const storeUserInfo = TCBReceiptApi.Protobuf.StoreUser.decode(
                        new Uint8Array(responseInfo.item)
                    );
                    console.log(storeUserInfo);
                    const failedCount = storeUserInfo.loginFailedCount as number;
                    this.errMsg.account = "密碼已錯誤" + failedCount + "次，您還有" + (5 - failedCount) + "次機會";
                } else if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_USER_IS_LOCK) {
                    this.errMsg.identification = "此帳號已鎖定";
                } else if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_OVER_ONLINE_UPPER_LIMIT) {
                    this.errMsg.identification = "目前已達登入上限，請稍後再登入";
                } else {
                    this.errMsg.identification = "例外錯誤";
                }
                this.login.account = "";
                this.pwdOrigin = "";
                this.login.checkCode = "";
                this.refresh();
                return false;
            }else{
                // 登入成功
                console.log("####登入成功####");
                const userAuth = TCBReceiptApi.Protobuf.UserAuth.decode(
                    new Uint8Array(responseInfo.item)
                );
                // console.log(userAuth);
    
                Cookies.set("appToken", userAuth.token as string, { expires: 1, sameSite: 'strict' });
                if (userAuth.groupPermission && userAuth.groupPermission.permission) {
                    const userAuthPrivJson: string = JSON.stringify(userAuth.groupPermission.permission) as string;
                    Cookies.set("appUserAuthPrivJson", userAuthPrivJson, { sameSite: 'strict' });
                }
                Network.setAuth(AuthType.JWT, userAuth.token as string);
    
                // 紀錄登入狀態
                if (userAuth.loginType) {
                    const loginType = String(userAuth.loginType);
                    Cookies.set("loginType", loginType as string, { sameSite: 'strict' });
                }
                // 紀錄e2ee狀態
                if (userAuth.e2eeFlag) {
                    const e2eeFlag = String(userAuth.e2eeFlag);
                    Cookies.set("e2eeFlag", e2eeFlag as string, { sameSite: 'strict' });
                }
                // 紀錄資訊
                const userInfo: UserInfo = {
                    identification: this.login.identification as string,
                    account: this.login.account as string,
                };
                Cookies.set("appUserInfo", JSON.stringify(userInfo) as string, { sameSite: 'strict' });
                // 紀錄帳號類型
                if (userAuth.type === 4) { // 管理員帳號
                    Cookies.set("isAdmin", "1" as string, { sameSite: 'strict' });
                }
    
                this.$router.push("/announcement/list");
                /* send value */
            }
        }
    }

    private async refresh() {
        this.login.id = Math.floor(new Date().getTime() / 1000) as number;

        /* send value */
        const item = this.login as TCBReceiptApi.Protobuf.Login;
        const loginQuery = TCBReceiptApi.Protobuf.Login.encode(item).finish();

        await LoginModel.getCaptcha(loginQuery);
        /* send value */
        this.verificationCode.imgSrc = process.env.VUE_APP_API_BASE_URL + "/api/web_user/captcha/img?timestamp=" + this.login.id;
    }

    private changeInputType(type: number) {
        if (!this.isPwdShow) {
            this.isPwdShow = true;
        } else if (this.isPwdShow) {
            this.isPwdShow = false;
        }
    }

    /* 無法直接讀取"CapsLock"狀態，僅能依賴是否鍵入"CapsLock"切換且往後鍵入的字符來判斷是否有開啟"CapsLock" */
    /* 僅運作在英文輸入法 */

    // 判斷是否有切換"CapsLock"大寫鎖定鍵
    private eventKeyUp(event: KeyboardEvent) {
        // KeyPress 能觸發"Shift"與"CapsLock" 
        // ex.如果是"Shift"+"a" => 則觸發兩個事件，完全獨立觸發，判斷不到"Shift"狀態
        if (event.key === "CapsLock" && this.pwdOrigin.length > 0) {
            this.isCapsLock = !this.isCapsLock;
        }

        return;
    }

    // 判斷大小寫狀態
    private eventKeyPress(event: KeyboardEvent) {
        // KeyPress 不觸發"Shift"與"CapsLock" 
        // ex.如果是"Shift"+"a" => 僅觸發一個事件且帶有"Shift"狀態
        const e = event||window.Event;
        const isShiftKey = e.shiftKey ? true : false;

        if (
            (isShiftKey && e.key >= 'a' && e.key <= 'z') ||
            (!isShiftKey && e.key >= 'A' && e.key <= 'Z' && e.key != 'Enter')
        ) {
            this.isCapsLock = true;
        } else {
            this.isCapsLock = false;
        }

        return;
    }

    private eventEnter(event: KeyboardEvent) {
        if (event.key == "Enter") {
            this.checkAndSubmit();
        }
    }
}